export const GET_NOTATION_HEADER = 'GET_NOTATION_HEADER';
export const GET_NOTATION_RAW = 'GET_NOTATION_RAW';
export const GET_NOTATION_WXR = 'GET_NOTATION_WXR';
export const GET_JOURNALIST_BONUS = 'GET_JOURNALIST_BONUS';
export const UPDATE_JOURNALIST_BONUS = 'UPDATE_JOURNALIST_BONUS';
export const GET_NOTATION_COMPARE = 'GET_NOTATION_COMPARE';
export const GET_NOTATION_HEADER_COMPARE = 'GET_NOTATION_HEADER_COMPARE';
export const GET_NOTATION_COMPARE_ADDITIONAL_RIVALS =
  'GET_NOTATION_COMPARE_ADDITIONAL_RIVALS';
